import { render, staticRenderFns } from "./TabHeight.vue?vue&type=template&id=60770aa0&scoped=true&"
import script from "./TabHeight.vue?vue&type=script&lang=js&"
export * from "./TabHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60770aa0",
  null
  
)

export default component.exports